import React from 'react';
import classNames from 'classnames';
import styles from './animated-wrapper.module.scss';
import cssVars from '../../styles/css-vars.module.scss';
export const AnimatedWrapper = ({ isActive, color, className, children }) => {
    const [isAnimationEnabled, setIsAnimationEnabled] = React.useState(false);
    return (React.createElement("div", { className: classNames(styles.container, cssVars.reactionsContainer, {
            [styles.active]: isActive,
            [styles.isAnimationEnabled]: isAnimationEnabled,
        }, className), style: {
            color: `${color}`,
        }, onClick: () => !isActive && setIsAnimationEnabled(true) },
        React.createElement("div", { className: classNames(styles.pos1) },
            React.createElement("div", { className: classNames(styles.sparkle) })),
        React.createElement("div", { className: classNames(styles.pos2) },
            React.createElement("div", { className: classNames(styles.sparkle) })),
        React.createElement("div", { className: classNames(styles.pos3) },
            React.createElement("div", { className: classNames(styles.sparkle) })),
        React.createElement("div", { className: classNames(styles.pos4) },
            React.createElement("div", { className: classNames(styles.sparkle) })),
        React.createElement("div", { className: classNames(styles.ring) }),
        children));
};
//# sourceMappingURL=animated-wrapper.js.map